// extracted by mini-css-extract-plugin
export default {"footer":"wUYFp78y"};